import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stopPillar",
  "use": "icon-stopPillar-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-stopPillar\">\n<g>\n\t<rect x=\"20.256\" y=\"74.159\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" width=\"155.051\" height=\"51.681\" />\n\t<rect x=\"71.94\" y=\"74.159\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFF100\" width=\"51.684\" height=\"51.681\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol